const MISION_T = {
      str_title: "Misión y Visión",
      str_title_1: "Misión",
      str_p_1:  "Convertirnos en ejemplo de compromiso y calidad en la verificación del cumplimiento de las Licencias Urbanísticas y demás actuaciones, asegurando el cumplimiento de las normas urbanísticas vigentes y la eficiencia de los procesos establecidos.",
      str_title_2: "Visión",
      str_p_2: "Ser referente en el Área Metropolitana de Bucaramanga, como una organización enfocada a la calidad de sus servicios y la satisfacción del usuario generando bienestar y seguridad en la comunidad.",
}

export default MISION_T;